/**
 * Language Configuration
 * Supports English (en) and Chinese (zh)
 */

export const LANGUAGES = {
    // English (Default)
    en: {
        // Menu
        menu: {
            title: "Pirate Clash",
            subtitle: "Sail, plunder, clash\nevery wave fuels your Pirate Clash!",
            startButton: "Start Battle"
        },

        // Loading
        loading: {
            text: "Loading Pirate Clash...",
            percentage: "{{percent}}%"
        },

        // Game Status
        status: {
            kills: "Kills",
            gold: "Gold",
            enemies: "Enemies"
        },

        // Rescue System
        rescue: {
            prompt: "Resident Found ({{current}}/{{max}})",
            progress: "Rescuing ({{current}}/{{max}})",
            full: "Rescue Slots Full ({{max}}/{{max}})",
            buttonMobile: "Tap to Rescue",
            buttonDesktop: "Right Click to Rescue"
        },

        // Reward Video
        reward: {
            label: "Advertisement",
            countdown: "{{seconds}}s",
            skipButton: "Skip ({{seconds}}s)",
            skipButtonReady: "Skip Ad",
            playing: "Ad playing...",
            required: "Watch reward video to rescue"
        },

        // Player Ship
        player: {
            destroyed: "Ship Destroyed",
            respawning: "Respawning in {{seconds}}s...",
            levelUp: "Level Up!",
            maxLevel: "Max Level Reached"
        },

        // Upgrade System
        upgrade: {
            health: "Health Upgrade",
            attack: "Attack Upgrade",
            speed: "Speed Upgrade",
            maxed: "MAX",
            cost: "Cost: {{gold}} Gold",
            insufficient: "Not Enough Gold"
        },

        // Combat
        combat: {
            damage: "-{{value}}",
            critical: "CRITICAL!",
            kill: "Enemy Destroyed",
            goldEarned: "+{{gold}} Gold"
        },

        // Notifications
        notifications: {
            coinCollected: "+{{value}} Coin",
            healthPack: "+{{value}} Health",
            escortAdded: "Escort Boat Added",
            escortDestroyed: "Escort Boat Lost"
        },

        // Settings
        settings: {
            language: "Language",
            english: "English",
            chinese: "中文"
        }
    },

    // Chinese (Simplified)
    zh: {
        // Menu
        menu: {
            title: "海盗冲突",
            subtitle: "扬帆起航，掠夺宝藏\n每一波浪都助你成为海盗之王！",
            startButton: "开始战斗"
        },

        // Loading
        loading: {
            text: "加载海盗冲突中...",
            percentage: "{{percent}}%"
        },

        // Game Status
        status: {
            kills: "击杀",
            gold: "金币",
            enemies: "敌船"
        },

        // Rescue System
        rescue: {
            prompt: "发现待救居民 ({{current}}/{{max}})",
            progress: "救援海岛居民 ({{current}}/{{max}})",
            full: "救援船位已满 ({{max}}/{{max}})",
            buttonMobile: "点击救援",
            buttonDesktop: "右键救援"
        },

        // Reward Video
        reward: {
            label: "广告",
            countdown: "{{seconds}}秒",
            skipButton: "跳过 ({{seconds}}秒)",
            skipButtonReady: "跳过广告",
            playing: "广告播放中...",
            required: "观看奖励视频以进行救援"
        },

        // Player Ship
        player: {
            destroyed: "船只被摧毁",
            respawning: "{{seconds}}秒后复活...",
            levelUp: "升级！",
            maxLevel: "已达最高等级"
        },

        // Upgrade System
        upgrade: {
            health: "生命值升级",
            attack: "攻击力升级",
            speed: "速度升级",
            maxed: "已满级",
            cost: "花费: {{gold}} 金币",
            insufficient: "金币不足"
        },

        // Combat
        combat: {
            damage: "-{{value}}",
            critical: "暴击！",
            kill: "敌船被摧毁",
            goldEarned: "+{{gold}} 金币"
        },

        // Notifications
        notifications: {
            coinCollected: "+{{value}} 金币",
            healthPack: "+{{value}} 生命",
            escortAdded: "护航船已加入",
            escortDestroyed: "护航船被摧毁"
        },

        // Settings
        settings: {
            language: "语言",
            english: "English",
            chinese: "中文"
        }
    }
};

// Default language
export const DEFAULT_LANGUAGE = 'en';

// Available languages
export const AVAILABLE_LANGUAGES = [
    { code: 'en', name: 'English' },
    { code: 'zh', name: '中文' }
];
